var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovideoDelaerServiceMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74879 15.5C9.98351 14.5267 10.9932 13.3025 11.7099 11.9101C12.6346 10.2752 12.8809 8.34818 12.3967 6.53663C11.7134 4.27231 9.38853 2.90737 7.05456 3.40021C6.94008 3.40021 6.81798 3.40021 6.66534 3.44556C6.90886 2.37277 7.46631 1.39487 8.268 0.634113C8.41309 0.529008 8.59337 0.483023 8.77169 0.505633C12.8205 0.691686 16.0048 3.99977 15.9987 8.01366C15.9925 12.0275 12.7982 15.3261 8.74879 15.5Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 12.6667C8.65533 13.6898 8.14446 14.629 7.41224 15.3814C7.29627 15.4733 7.14802 15.5145 7.00121 15.4955C3.12899 15.2168 0.100864 12.0474 0.00246105 8.17019C-0.0959416 4.29297 2.76752 0.974331 6.62063 0.5C6.44556 0.652084 6.32378 0.758542 6.2096 0.872605C3.96458 2.91166 2.91204 5.9516 3.41614 8.94065C3.59752 10.118 4.24244 11.1741 5.20739 11.8739C6.17234 12.5737 7.37725 12.8591 8.55398 12.6667C8.66548 12.659 8.77739 12.659 8.88889 12.6667Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23576 8.24597C6.23576 7.57717 6.23576 6.91572 6.23576 6.25427C6.23576 5.59282 6.49402 5.51932 6.98959 5.79125C8.10637 6.44535 9.22315 7.10681 10.326 7.77561C10.7797 8.04754 10.7797 8.36357 10.326 8.6355C9.19523 9.32635 8.06449 10.0025 6.91979 10.6713C6.50798 10.9138 6.2218 10.7668 6.2218 10.2744C6.2218 9.59828 6.2218 8.92212 6.2218 8.24597",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovideoDelaerServiceMiniLogo);
export default __webpack_public_path__ + "static/media/covideo_delaer_service_mini_logo.e3896bf59bd0fc53dbc3553445b30e7d.svg";
export { ForwardRef as ReactComponent };